var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';

/* TYPES */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */

function clamp(max, n) {
  return Math.min(max - 1, Math.max(0, n));
}
function wrap(max, n) {
  if (max === 0) {
    return n;
  }
  return n < 0 ? max + n : n % max;
}

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function useListNavigation(_ref) {
  var _ref$circular = _ref.circular,
    circular = _ref$circular === void 0 ? false : _ref$circular,
    _ref$initialIndex = _ref.initialIndex,
    initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
    _ref$size = _ref.size,
    initialSize = _ref$size === void 0 ? 0 : _ref$size;
  var _React$useState = React.useState(initialIndex),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    index = _React$useState2[0],
    setIndex = _React$useState2[1];
  var _React$useState3 = React.useState(initialSize),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    size = _React$useState4[0],
    setSize = _React$useState4[1];
  var set = React.useCallback(function (i) {
    if (size === 0) {
      setIndex(i);
    } else {
      setIndex(clamp(size, circular ? wrap(size, i) : i));
    }
  }, [circular, size]);
  function clear() {
    set(0);
  }
  function increment() {
    set(index + 1);
  }
  function incrementBy(amount) {
    set(index + amount);
  }
  function decrement() {
    set(index - 1);
  }
  function decrementBy(amount) {
    set(index - amount);
  }
  function reset() {
    set(initialIndex);
  }
  return {
    clear: clear,
    decrement: decrement,
    decrementBy: decrementBy,
    increment: increment,
    incrementBy: incrementBy,
    index: index,
    reset: reset,
    set: set,
    setSize: setSize,
    size: size
  };
}

/* RENDER PROP */

/**
 * @deprecatedSince 9
 * @deprecated Never officially documented/supported
 */
export function ListNavigation(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var listNavigation = useListNavigation(props);
  return typeof children === 'function' ? children(listNavigation) : children;
}
//# sourceMappingURL=ListNavigation.js.map